__turbopack_context__.v({
  "ra-product-sticky-footer": "_3IDhNa_ra-product-sticky-footer",
  "ra-product-sticky-footer--active": "_3IDhNa_ra-product-sticky-footer--active",
  "ra-product-sticky-footer__content": "_3IDhNa_ra-product-sticky-footer__content",
  "ra-product-sticky-footer__content__buttons": "_3IDhNa_ra-product-sticky-footer__content__buttons",
  "ra-product-sticky-footer__content__duration": "_3IDhNa_ra-product-sticky-footer__content__duration",
  "ra-product-sticky-footer__content__meta": "_3IDhNa_ra-product-sticky-footer__content__meta",
  "ra-product-sticky-footer__content__text": "_3IDhNa_ra-product-sticky-footer__content__text",
});
